APP.init = function () {
	$('select').select2({
		minimumResultsForSearch: -1,
		width: 'resolve',
		templateSelection: function (data, container) {
			if (data.id !== '') {
				$(container).addClass('select2-selection__rendered--value');
			} else {
				$(container).removeClass('select2-selection__rendered--value');
			}
			return data.text;
		},
	});

	$('[data-modal]').on('click', function (e) {
		e.preventDefault();
		const obj = $(this);
		const modalShow = obj.data('modal');
		if (modalShow) APP.modal(modalShow);
	});

	APP.device();
	APP.header();
	APP.modal();
	APP.video();
	APP.form();
};
